import React, {Component} from 'react';
import '../styles/PacketView.css';

class PacketView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {
                fresher: false,
                rules: []
            }
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(JSON.stringify(nextProps.data) !== JSON.stringify(prevState.data)) {
            return {
                data: nextProps.data
            }
        }
        return null
    }
    
    render() {
        const { data: { fresher, rules } } = this.state
        const { handleBuyPacket } = this.props

        return (
            <div className="view-packet">
                <div className="title">
                    <i className='iconfont icon-youxiyouxiji' style={{fontSize:20}}></i>
                    <span> 游戏套餐</span>
                    <span className="sub"></span>
                </div>
                <div className="wrapper-packet-rule">
                    {rules.map((rule, index) => {
                        let useFresherPrice = fresher&&rule.fresherPrice
                        let ruleName = rule.name ? rule.name : `${rule.gameMinutes}分钟套餐`
                        let ruleTip = rule.description ? rule.description : ruleName
                        let ruleLabel = useFresherPrice ? '新用户' : (rule.label ? rule.label : null) 
                        return (
                            <div key={rule.id} className='packet-rule' onClick={() => {handleBuyPacket(rule)}}>
                                <div className='description'>
                                    <div className='name word-ellipsis'>
                                        <span>{ruleName}</span>
                                        <span className={`rule-tag${ruleLabel?'':' hidden'}`}>{ruleLabel}</span>
                                    </div>
                                    <div className='tip word-ellipsis'>{ruleTip}</div>
                                </div>
                                <div className="price">
                                    <div className={`original${useFresherPrice?'':' hidden'}`}>￥{rule.price}</div>
                                    <div className='real'>￥{useFresherPrice?rule.fresherPrice:rule.price}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default PacketView;


// WEBPACK FOOTER //
// ./src/components/PacketView.js